import { appConstants } from "constants/appConstants";
import { t } from "i18next";

export function convertHoursToDays(hours: number, language: String = appConstants.LANGUAGE.DEFAULT_LANGUAGE): String {
  const days = Math.floor(hours / 24);
  const remainingHours = Math.floor(hours % 24);
  const minutes = Math.floor((hours % 1) * 60);

  let times = [];

  if (days > 0) times.push(`${days} ${t("days")}`);

  if (remainingHours > 0) times.push(`${remainingHours} ${t("hours")}`);

  if (minutes > 0) times.push(`${minutes} ${t("minutes")}`);

  return times.join(" ").toString();
}

export function convertHoursToHourMinutes(hours: number, language: String = appConstants.LANGUAGE.DEFAULT_LANGUAGE): String {
  const totalHours = Math.floor(hours);
  const minutes = Math.floor((hours % 1) * 60);

  let times = [];

  if (totalHours >= 0) times.push(`${totalHours} ${t("hours")}`);

  if (minutes > 0) times.push(`${minutes} ${t("minutes")}`);

  return times.join(" ").toString();
}
